import { onCLS, onFID, onFCP, onLCP, onTTFB, type Metric } from 'web-vitals';
import { getAppInsightsInstance } from './appInsights';

const isDevelopment = import.meta.env.DEV;

export const logEvent = (message: string, properties: Record<string, unknown> = {}): void => {
  const timestamp = new Date().toISOString();
  const enrichedProps = { ...properties, timestamp };

  const appInsights = getAppInsightsInstance();
  if (appInsights) {
    appInsights.trackEvent({ name: message, properties: enrichedProps });
    if (isDevelopment) appInsights.flush();
  }

  if (isDevelopment) console.log(`[${timestamp}] EVENT:`, message, enrichedProps);
};

export const logError = (message: string, error: Error | null = null, properties: Record<string, unknown> = {}): void => {
  const timestamp = new Date().toISOString();
  const exception = error instanceof Error ? error : new Error(message);
  const enrichedProps = { ...properties, timestamp };

  const appInsights = getAppInsightsInstance();
  if (appInsights) {
    appInsights.trackException({ exception, properties: enrichedProps });
    if (isDevelopment) appInsights.flush();
  }

  if (isDevelopment) console.error(`[${timestamp}] ERROR:`, message, error, enrichedProps);
};

export const logMetric = (name: string, value: number, properties: Record<string, unknown> = {}): void => {
  const appInsights = getAppInsightsInstance();
  if (appInsights) {
    appInsights.trackMetric({ name, average: value, properties: { ...properties } });
    if (isDevelopment) appInsights.flush();
  }

  if (isDevelopment) console.log(`[METRIC] ${name}: ${value}`, properties);
};

// Core Web Vitals -> App Insights metrics.
export const initWebVitals = (): void => {
  const report = (metric: Metric) => logMetric(metric.name, metric.value, { id: metric.id });

  onCLS(report);
  onFID(report);
  onFCP(report);
  onLCP(report);
  onTTFB(report);
};
